import * as React from 'react';
var entityDefaults = {
  context: {}
};
var EntityContext = React.createContext(entityDefaults);
/**
 * Provider component for entity context to the React tree.
 */
export var EntityContextProvider = function (props) {
  return React.createElement(EntityContext.Provider, {
    value: props.EntityContext || entityDefaults
  }, props.children || null);
};
EntityContextProvider.displayName = 'EntityContextProvider';
export var useEntityContext = function (domainName) {
  var entityContext = React.useContext(EntityContext);
  return entityContext.context[domainName];
};